var e = {
	list: {
		title: "Pricing Rules",
		subtitle: "Define dynamic pricing rules for your listings.",
		createRule: "Create Rule",
		empty: {
			message: "No pricing rules yet. Create your first rule to start managing dynamic pricing.",
			action: "Create your first rule",
			quickRulesActive_one: "{{count}} quick rule is active on your listings — manage it from that listing.",
			quickRulesActive_other: "{{count}} quick rules are active on your listings — manage them from each listing."
		},
		listingsCount_one: "{{count}} listing",
		listingsCount_other: "{{count}} listings"
	},
	card: {
		priceCalculation: "Price Calculation",
		noListings: "No listings",
		linkedListings_one: "{{count}} listing",
		linkedListings_other: "{{count}} listings",
		updated: "Updated {{date}}",
		actions: "Actions",
		editRule: "Edit Rule",
		deleteRule: "Delete Rule",
		deleteConfirm: "Delete rule \"{{title}}\"? This cannot be undone."
	},
	details: {
		breadcrumbRules: "Pricing Rules",
		breadcrumbDetails: "Details",
		notFound: "Rule not found.",
		simulate: "Simulate",
		assignListings: "Assign Listings",
		editRule: "Edit Rule",
		assignedListings: "Assigned Listings",
		assignedCount_one: "({{count}} listing)",
		assignedCount_other: "({{count}} listings)",
		trigger: "Trigger",
		updated: "Updated",
		statusActive: "Active",
		statusInactive: "Turned off",
		noAssignedTitle: "No listings assigned to this rule",
		viewOnlyNote: "Rules are created and edited on the web dashboard.",
		andMore_one: "and {{count}} more listing",
		andMore_other: "and {{count}} more listings"
	},
	assignedListings: {
		empty: {
			title: "No listings assigned to this rule",
			description: "Click “Assign Listings” to link listings to this rule."
		},
		imageAlt: "Listing",
		unitInFallback: "Unit in {{address}}",
		location: "{{city}}, {{country}}",
		beds_one: "{{count}} bed",
		beds_other: "{{count}} beds",
		baths_one: "{{count}} bath",
		baths_other: "{{count}} baths",
		unassign: "Unassign listing"
	},
	assignModal: {
		title: "Assign Listings",
		searchPlaceholder: "Search by title, address, city...",
		moreFilters: "More Filters",
		noResults: "No listings found. Try adjusting your search or filters.",
		selected_one: "{{count}} listing selected",
		selected_other: "{{count}} listings selected",
		assigning: "Assigning...",
		assign_one: "Assign {{count}} listing",
		assign_other: "Assign {{count}} listings",
		beds_one: "{{count}} bed",
		beds_other: "{{count}} beds",
		assignError: "We couldn't assign this rule. Nothing was changed — please try again."
	},
	simulate: {
		title: "Simulate Rule",
		description: "Test how this pricing rule affects a specific listing",
		back: "Back",
		newSimulation: "New Simulation",
		untitledListing: "Untitled",
		perNight: "· {{price}} {{currency}}/night",
		modeCalendar: "· Calendar",
		modeCheckout: "· Checkout",
		listingSelector: {
			label: "Select a Listing",
			placeholder: "Choose a listing to simulate against...",
			untitled: "Untitled Listing",
			option: "{{city}}, {{country}} · {{price}} {{currency}}/night"
		},
		mode: {
			heading: "Choose Simulation Mode",
			calendarTitle: "Calendar Preview",
			calendarDescription: "See how this rule affects nightly rates across a date range. Only cell-level conditions (day of week, date range) evaluate.",
			checkoutTitle: "Checkout Calculation",
			checkoutDescription: "Simulate a full booking with guests, dates, fees, and totals. All conditions evaluate (trip-level + cell-level)."
		},
		preview: {
			heading: "Calendar Preview Parameters",
			startDate: "Start Date",
			endDate: "End Date",
			startDateRequired: "Select a start date",
			endDateRequired: "Select an end date",
			endAfterStart: "End date must be after the start date"
		},
		checkout: {
			heading: "Checkout Parameters",
			checkIn: "Check-in Date",
			checkOut: "Check-out Date",
			guests: "Guests",
			checkInRequired: "Select a check-in date",
			checkOutRequired: "Select a check-out date",
			guestsMin: "At least one guest",
			checkOutAfterCheckIn: "Check-out must be after check-in"
		},
		runSimulation: "Run Simulation",
		result: {
			loading: "Analyzing pricing rules...",
			failed: "Simulation failed. Please try again.",
			aiUnavailable: "The written summary is unavailable, but the result above is complete.",
			perNight: "Per night",
			nights: "Nights",
			nightlyTotal: "Nightly total",
			fees: "Fees",
			total: "Total"
		},
		listingStep: {
			title: "Which listing should we test against?",
			empty: "Assign this rule to a listing before simulating it."
		},
		modeSegmentCalendar: "Calendar",
		modeSegmentCheckout: "Checkout"
	},
	admin: { pricelabs: {
		inbox: {
			title: "PriceLabs inbox",
			subtitle: "Every rate push PriceLabs has signed and sent us, and what became of it.",
			payloadNotice: "This page shows the delivery envelope, never the body PriceLabs sent. The stored payload is kept verbatim for triage and read from the database when it is genuinely needed — the diagnosis you want is in the Reason column.",
			quarantineNotice: "A quarantined delivery is parked until a human releases it: the drain skips it and the reconciliation sweep does not offer it. Fix the cause first — usually a listing that is not enabled for PriceLabs — then use Requeue on the row, which resets its retries and puts it back in the sweep's queue. Releasing a row whose cause still stands just quarantines it again.",
			stats: {
				quarantined: "Quarantined",
				quarantinedHint: "We could not act on these. Parked until somebody fixes the cause and requeues the row.",
				retryable: "Retrying",
				retryableHint: "Transient failures the reconciliation job is still working through.",
				pending: "Pending",
				pendingHint: "Captured, waiting for the drain. Seconds, normally.",
				processed: "Processed",
				processedHint: "Drained. Most of this table, and part of the answer.",
				oldest: "Oldest unresolved",
				oldestNone: "Nothing parked",
				dlqDepth: "Dead-lettered",
				dlqDepthHint: "Parked on pricing.pricelabs_webhook_inbox.",
				dlqUnavailable: "Pricing did not answer — this is not a zero."
			},
			filters: {
				allStatuses: "Any status",
				allKinds: "Any receiver"
			},
			status: {
				pending: "Pending",
				processed: "Processed",
				failed_retryable: "Retrying",
				quarantined: "Quarantined"
			},
			kind: {
				sync: "Rates",
				calendar_trigger: "Calendar trigger",
				hook: "Error hook"
			},
			columns: {
				request: "Request",
				kind: "Receiver",
				listing: "PriceLabs listing",
				status: "Status",
				retries: "Retries",
				reason: "Reason",
				received: "Captured"
			},
			noReason: "—",
			noListing: "—",
			redrive: {
				action: "Redrive dead-lettered",
				running: "Redriving…",
				confirmTitle: "Redrive the PriceLabs inbox queue?",
				confirmBody: "Re-publishes every message parked on pricing.pricelabs_webhook_inbox so the drain can try again. Quarantined rows are not reached — release those one at a time with Requeue on the row.",
				confirm: "Redrive",
				done_one: "Redrove {{count}} message.",
				done_other: "Redrove {{count}} messages.",
				nothing: "Nothing was parked.",
				failed: "Could not redrive the queue."
			},
			requeue: {
				action: "Requeue",
				running: "Requeuing…",
				confirmTitle: "Release this delivery back to the queue?",
				confirmBody: "Delivery {{requestId}} goes back to pending with its retry count reset, and the reconciliation sweep retries it on its next tick — within 10 minutes. Do this only after you have fixed what parked it, usually by enabling the listing for PriceLabs: releasing a row whose cause still stands simply quarantines it again.",
				confirm: "Requeue delivery",
				done: "Released back to the queue — the sweep retries it within {{minutes}} minutes, with retries reset.",
				failed: "Could not requeue that delivery."
			},
			empty: {
				title: "Nothing has arrived yet",
				body: "PriceLabs has not signed a delivery to this environment. That is the expected state until the callback URLs are registered."
			},
			filtered: {
				title: "No deliveries match",
				body: "Clear the filters to see the whole inbox."
			}
		},
		health: {
			title: "PriceLabs sync health",
			subtitle: "Which workspaces are linked, and which of their listings PriceLabs has stopped sending rates for.",
			staleNotice: "“Stale” means no rates for over {{hours}} hours — the same window the sync-health and calendar-reconciliation jobs use. A listing that has never synced is not stale; it is waiting for PriceLabs’ first push.",
			tabs: {
				connections: "Connections",
				listings: "Listings"
			},
			stats: {
				connected: "Connected workspaces",
				connectedHint_one: "{{count}} has disconnected.",
				connectedHint_other: "{{count}} have disconnected.",
				enabled: "Listings on PriceLabs",
				enabledHint: "{{live}} live · {{pushing}} still pushing",
				stale: "Stale",
				staleHint: "No rates for over {{hours}}h.",
				errors: "Sync failures",
				errorsHint: "The enable-time push did not finish.",
				awaiting: "Awaiting first sync",
				awaitingHint: "Pushed, waiting for the first rates. Not a fault."
			},
			connections: {
				columns: {
					workspace: "Workspace",
					account: "PriceLabs account",
					status: "Status",
					connected: "Connected",
					listings: "Listings",
					lastSync: "Last rates"
				},
				active: "Connected",
				inactive: "Disconnected",
				listingsValue: "{{enabled}} of {{total}} enabled",
				viewListings: "View listings",
				filters: {
					all: "All connections",
					active: "Connected only",
					inactive: "Disconnected only"
				},
				empty: {
					title: "No workspace has linked PriceLabs",
					body: "A host links their own PriceLabs account from Settings → Integrations."
				},
				filtered: {
					title: "No connections match",
					body: "Clear the filter to see every workspace."
				}
			},
			listings: {
				columns: {
					listing: "Listing",
					workspace: "Workspace",
					pricelabsId: "PriceLabs id",
					state: "Sync state",
					lastSync: "Last rates",
					error: "Last error"
				},
				disabled: "Disabled",
				stale: "Stale",
				awaitingFirstSync: "Awaiting first sync",
				never: "Never",
				noError: "—",
				workspaceFilter: "Showing one workspace.",
				clearWorkspace: "Show all workspaces",
				filters: {
					allStates: "Any sync state",
					allHealth: "Any freshness",
					staleOnly: "Stale only",
					freshOnly: "Not stale"
				},
				empty: {
					title: "No listing is on PriceLabs yet",
					body: "A host switches PriceLabs on per listing, once their workspace is connected."
				},
				filtered: {
					title: "No listings match",
					body: "Clear the filters to see every listing."
				}
			}
		}
	} },
	slot: {
		perPerson: "{{price}} per person",
		perGroup: "{{price}} for the group",
		minimumGroupLine: "Charged for {{count}} — the host's minimum",
		privateGroupDelta: "{{price}} more to book the whole session"
	},
	partnerPricing: {
		cardTitle: "Priced by an integration",
		cardDescription: "An integration is supplying this listing's nightly rates. Your own pricing rules are paused while it does.",
		pricedBy: "Priced by {{partner}}",
		pricedByUnknown: "Priced by a connected integration",
		coverage: "Rates through {{date}}",
		coverageNone: "No rate for tonight — this listing cannot be booked until the integration sends one",
		gaps_one: "{{count}} night in the next 90 has no rate and cannot be booked",
		gaps_other: "{{count}} nights in the next 90 have no rate and cannot be booked",
		lastUpdate: "Last update {{time}}",
		lastUpdateNever: "No rates received yet",
		release: "Take pricing back",
		releaseConfirmTitle: "Take pricing back?",
		releaseConfirmBody: "This listing returns to your own pricing. The rates the integration sent are kept but stop being used, and your pricing rules stay paused — re-enable the ones you still want.",
		releaseConfirmAction: "Take pricing back",
		released: "This listing is back on your own pricing",
		releaseError: "Could not take pricing back. Nothing changed — try again.",
		readOnly: "Only someone with permission to manage pricing can take this listing back."
	}
};
//#endregion
export { e as default };
